<template>
  <expandable header="Previous Admission Details" class="mb-10">
    <b-row>
      <b-col cols="12" md="4">
        <yes-no
          label="Shifted from Another Hospital"
          @input="onInput"
          :disabled="isDisabled"
          v-model="form.shifted_from_hospital"
          rules="required"
        ></yes-no>
      </b-col>
      <template v-if="form.shifted_from_hospital == 1">
        <b-col cols="12" md="4">
          <input-field
            :disabled="isDisabled"
            v-model.trim="form.previous_admission_hospital"
            @input="onInput"
            label="Previous Admission Hospital"
            rules="max-250"
          ></input-field>
        </b-col>
        <b-col cols="12" md="4">
          <date-picker
            :disabled="isDisabled"
            v-model="form.previous_admission_date"
            @input="onInput"
            label="Previous Admission Date"
            rules=""
          ></date-picker>
        </b-col>
        <b-col cols="12" md="4">
          <input-field
            :disabled="isDisabled"
            v-model.trim="form.previous_admission_details"
            @input="onInput"
            label="Previous Admission Details"
            rules="max-500"
          ></input-field>
        </b-col>
        <b-col cols="12" md="4">
          <file-input-group
            v-model.trim="form.shifted_hospital_document"
            label="Shifting Document"
            :disabled="isDisabled"
            accept=".jpg,capture=camera,.jpeg,.png,.pdf"
            @input="onInput"
            rules="file-image-pdf|file-size"
          ></file-input-group>
        </b-col>
      </template>
    </b-row>
  </expandable>
</template>

<script>
import Expandable from "../../Expandable.vue";
import InputField from "../../form/InputField.vue";
import DatePicker from "../../form/DatePicker.vue";
import YesNo from "../../form/YesNo.vue";
import FileInputGroup from "../../form/FileInputGroup.vue";
export default {
  props: {
    value: {},
    isDisabled: {
      default: false,
      type: Boolean,
    },
  },
  components: {
    Expandable,
    InputField,
    DatePicker,
    YesNo,
    FileInputGroup,
  },
  data() {
    return {
      form: {},
    };
  },
  methods: {
    onInput() {
      this.$emit("input", this.form);
    },
  },
  beforeMount() {
    this.form = this.value;
  },
};
</script>

<style></style>
